import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function Terms() {
  return (
    <>
      <Navbar />
      <main>
        {/* Hero */}
        <section className="pt-28 pb-16 px-4 md:px-6 bg-background-100">
          <div className="mx-auto max-w-3xl text-center">
            <h1 className="font-heading text-3xl md:text-5xl text-foreground-950 mb-4">服务条款</h1>
            <p className="text-sm text-foreground-500">最后更新：2026年6月</p>
          </div>
        </section>

        {/* Content */}
        <section className="py-16 md:py-20 px-4 md:px-6">
          <article className="mx-auto max-w-3xl">
            <div className="space-y-12">
              {/* Section 1 */}
              <div>
                <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-4">1. 服务概述</h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  欢迎使用bbgpt.online（以下简称"我们"或"本平台"）提供的在线AI教育培训服务。通过访问或使用本平台，即表示你同意遵守本服务条款（以下简称"条款"）以及所有适用的法律法规。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  如果你不同意本条款的任何内容，请勿注册、访问或使用本平台的任何服务。
                </p>
              </div>

              {/* Section 2 */}
              <div>
                <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-4">2. 账户注册与管理</h2>
                <ul className="space-y-3">
                  <li className="text-sm text-foreground-600 leading-relaxed">
                    <strong className="text-foreground-900">2.1 注册要求：</strong>你须年满18周岁，或已获得法定监护人的同意，方可注册本平台账户。注册时须提供真实、准确、完整的个人信息。
                  </li>
                  <li className="text-sm text-foreground-600 leading-relaxed">
                    <strong className="text-foreground-900">2.2 账户安全：</strong>你应对自己的账户凭据保密，并对账户下的所有活动负责。如发现未经授权使用你账户的情况，请立即通知我们。
                  </li>
                  <li className="text-sm text-foreground-600 leading-relaxed">
                    <strong className="text-foreground-900">2.3 账户限制：</strong>每个自然人仅允许注册一个账户。我们保留拒绝服务、终止账户、删除或编辑内容的权利。
                  </li>
                </ul>
              </div>

              {/* Section 3 */}
              <div>
                <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-4">3. 课程购买与使用</h2>
                <ul className="space-y-3">
                  <li className="text-sm text-foreground-600 leading-relaxed">
                    <strong className="text-foreground-900">3.1 课程定价：</strong>所有课程价格以购买时页面显示为准。我们保留调整课程价格的权利，价格调整不影响已完成的购买。
                  </li>
                  <li className="text-sm text-foreground-600 leading-relaxed">
                    <strong className="text-foreground-900">3.2 课程访问：</strong>购买课程后，你将获得对应课程内容的在线访问权限，权限有效期以课程说明为准。
                  </li>
                  <li className="text-sm text-foreground-600 leading-relaxed">
                    <strong className="text-foreground-900">3.3 个人使用：</strong>课程内容仅供你个人学习使用。严禁将课程账号共享、转售给他人，或以任何形式公开传播课程内容。
                  </li>
                  <li className="text-sm text-foreground-600 leading-relaxed">
                    <strong className="text-foreground-900">3.4 学习支持：</strong>我们将按课程说明提供相应的学习支持服务，包括但不限于社群答疑、导师辅导等。
                  </li>
                </ul>
              </div>

              {/* Section 4 */}
              <div>
                <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-4">4. 支付条款</h2>
                <ul className="space-y-3">
                  <li className="text-sm text-foreground-600 leading-relaxed">
                    <strong className="text-foreground-900">4.1 支付方式：</strong>我们支持支付宝、微信支付、银行转账等支付方式。你需确保所使用的支付方式归属于你本人或已获得合法授权。
                  </li>
                  <li className="text-sm text-foreground-600 leading-relaxed">
                    <strong className="text-foreground-900">4.2 分期付款：</strong>部分课程支持分期付款。选择分期付款即表示你同意按期支付所有款项，如发生逾期可能影响课程访问权限。
                  </li>
                  <li className="text-sm text-foreground-600 leading-relaxed">
                    <strong className="text-foreground-900">4.3 发票：</strong>完成支付后可申请开具电子发票。请在订单完成后30天内通过客服渠道提出申请。
                  </li>
                </ul>
              </div>

              {/* Section 5 */}
              <div>
                <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-4">5. 知识产权</h2>
                <ul className="space-y-3">
                  <li className="text-sm text-foreground-600 leading-relaxed">
                    <strong className="text-foreground-900">5.1 平台内容：</strong>本平台提供的所有课程视频、讲义、代码、练习题、项目资料等内容的知识产权均归bbgpt.online或其授权方所有，受中国著作权法和其他知识产权法律的保护。
                  </li>
                  <li className="text-sm text-foreground-600 leading-relaxed">
                    <strong className="text-foreground-900">5.2 禁止行为：</strong>你不得对课程内容进行录制、下载、复制、修改、分发、转售、公开展示或创建衍生作品，除非获得我们的明确书面许可。
                  </li>
                  <li className="text-sm text-foreground-600 leading-relaxed">
                    <strong className="text-foreground-900">5.3 学员作品：</strong>你在课程学习过程中创作的代码和项目作品，其知识产权归你所有。但你可能需要遵守课程项目中使用的第三方代码或框架的开源许可协议。
                  </li>
                </ul>
              </div>

              {/* Section 6 */}
              <div>
                <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-4">6. 用户行为规范</h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">在使用本平台过程中，你同意不从事以下行为：</p>
                <ul className="space-y-2">
                  <li className="flex items-start gap-2 text-sm text-foreground-600">
                    <span className="text-foreground-300 mt-0.5">•</span>
                    <span>发布违法、侵权、骚扰、诽谤、淫秽或其他不当内容</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-foreground-600">
                    <span className="text-foreground-300 mt-0.5">•</span>
                    <span>干扰或破坏本平台的正常运行（包括传播病毒、恶意软件等）</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-foreground-600">
                    <span className="text-foreground-300 mt-0.5">•</span>
                    <span>使用自动化工具（爬虫、脚本等）批量访问或抓取平台内容</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-foreground-600">
                    <span className="text-foreground-300 mt-0.5">•</span>
                    <span>反向工程、反编译或试图获取平台源代码</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-foreground-600">
                    <span className="text-foreground-300 mt-0.5">•</span>
                    <span>冒充他人或提供虚假信息</span>
                  </li>
                </ul>
              </div>

              {/* Section 7 */}
              <div>
                <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-4">7. 退款政策</h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  课程属于数字化知识服务产品，<strong>购买后默认不予退款</strong>。仅在学员本人因长期住院、重大疾病或意外事故等极端特殊情况导致确实无法继续学习时，须提供有效的官方证明文件，方可申请特殊退款审核。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  退款政策的最新版本详见我们的
                  <a href="/refund-policy" className="text-primary-500 hover:text-primary-600 mx-1 cursor-pointer">退款政策</a>
                  页面。退款政策是本服务条款的重要组成部分，一经购买即表示你已充分理解并同意上述退款政策。
                </p>
              </div>

              {/* Section 8 */}
              <div>
                <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-4">8. 免责声明</h2>
                <ul className="space-y-3">
                  <li className="text-sm text-foreground-600 leading-relaxed">
                    <strong className="text-foreground-900">8.1 学习效果：</strong>课程学习效果因人而异，取决于个人的学习投入、基础水平和实践情况。我们不保证特定学习成果或就业结果。
                  </li>
                  <li className="text-sm text-foreground-600 leading-relaxed">
                    <strong className="text-foreground-900">8.2 服务中断：</strong>我们尽最大努力保障服务的连续性和稳定性，但对于因不可抗力、系统维护、网络故障等原因导致的服务中断，我们不承担责任。
                  </li>
                  <li className="text-sm text-foreground-600 leading-relaxed">
                    <strong className="text-foreground-900">8.3 第三方链接：</strong>平台可能包含第三方网站或资源的链接，我们对这些外部内容不承担任何责任。
                  </li>
                </ul>
              </div>

              {/* Section 9 */}
              <div>
                <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-4">9. 隐私保护</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  我们重视你的隐私。关于我们如何收集、使用和保护你的个人信息，请参阅我们的隐私政策。使用本平台即表示你同意我们的隐私数据处理方式。
                </p>
              </div>

              {/* Section 10 */}
              <div>
                <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-4">10. 条款变更</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  我们保留随时修改本服务条款的权利。修改后的条款将在平台上公布后生效。重大变更我们将通过邮件或平台通知的方式告知你。继续使用本平台即表示你接受修改后的条款。如不同意修改，你应停止使用本平台。
                </p>
              </div>

              {/* Section 11 */}
              <div>
                <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-4">11. 适用法律与争议解决</h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  本条款受中华人民共和国法律管辖并依其解释。因本条款引起的或与之相关的任何争议，双方应首先友好协商解决。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  协商不成的，任何一方均有权将争议提交至bbgpt.online所在地有管辖权的人民法院诉讼解决。
                </p>
              </div>

              {/* Section 12 */}
              <div>
                <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-4">12. 联系我们</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  如对本服务条款有任何疑问或意见，请通过以下方式联系我们：
                </p>
                <ul className="mt-3 space-y-2">
                  <li className="flex items-center gap-2 text-sm text-foreground-600">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-mail-line text-primary-500 text-sm"></i>
                    </div>
                    邮箱：legal@aifuture.academy
                  </li>
                  <li className="flex items-center gap-2 text-sm text-foreground-600">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-map-pin-line text-primary-500 text-sm"></i>
                    </div>
                    地址：海南省海口市美兰区新埠街道新埠岛新埠路9号海南自贸港跨境电商产业园主楼北侧三层东区301-22
                  </li>
                </ul>
              </div>
            </div>
          </article>
        </section>
      </main>
      <Footer />
    </>
  );
}